import { Link } from "react-router-dom";
import { buttonVariants } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import type { Wallet, WalletStatus } from "@/types";

const STATUS_META: Record<WalletStatus, { label: string; variant: "success" | "danger" | "pending" | "neutral" }> = {
  active: { label: "Active", variant: "success" },
  frozen: { label: "Frozen", variant: "danger" },
  pending: { label: "Pending", variant: "pending" },
  sandbox: { label: "Sandbox", variant: "neutral" },
};

export default function WalletMissing({ id, wallet }: { id: string; wallet?: Wallet }) {
  const status = wallet ? STATUS_META[wallet.status] : null;

  return (
    <div className="mx-auto mt-10 max-w-[520px] rounded-lg border border-line bg-surface p-6 text-center">
      <span aria-hidden className="text-2xl">🔍</span>
      <h1 className="mt-2 text-lg font-bold text-ink">{wallet ? wallet.name : "Wallet not found"}</h1>
      {status && (
        <div className="mt-2 flex justify-center">
          <Badge variant={status.variant} dot={false}>{status.label}</Badge>
        </div>
      )}
      <p className="mx-auto mt-2 max-w-[380px] text-[12.5px] leading-relaxed text-muted">
        {wallet
          ? `Balance and route detail is currently available for the operations hot wallet (WLT-001) only. Full detail for "${wallet.id}" hasn't been built yet.`
          : `No wallet matches "${id}". Balance and route detail is currently available for the operations hot wallet (WLT-001).`}
      </p>
      {wallet?.status === "pending" && (
        <div className="mt-3">
          <Link
            to={`/wallets/new?step=created&id=${wallet.id}`}
            className="text-[12.5px] font-semibold text-primary hover:underline"
          >
            View creation status →
          </Link>
        </div>
      )}
      <div className="mt-4">
        <Link to="/wallets" className={buttonVariants({ variant: "primary" })}>
          Back to Wallets
        </Link>
      </div>
    </div>
  );
}
